import React, { useState, useRef, useEffect } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

type FormData = {
  description_name: string;
};

const AddPropertyStructure: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    description_name: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [dataExistMessage, setDataExistMessage] = useState<string>("");

  const formRef = useRef<HTMLFormElement>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const resetForm = () => {
    setFormData({
      description_name: "",
    });
    setErrors({
      description_name: "",
    });
  };

  const validateForm = (): boolean => {
    const newErrors: any = {};
    if (!formData.description_name.trim()) newErrors.description_name = "Structure Type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const response = await axiosInstance.post(`${API_URLS.addUseOfProperty}`, formData);

        if (response.data.data.message) {
          resetForm();
          setDataExistMessage(`${response.data.data.message}`);
          setTimeout(() => {
            setDataExistMessage("");
          }, 5000);
        } else {
          resetForm();
          setSuccessMessage(`${response.data.message}`);
          setTimeout(() => {
            setSuccessMessage("");
          }, 5000);
        }

        setErrors({});
      } catch (error) {
        setSuccessMessage("Property Structre Add failed.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
      }
    }
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (formRef.current && !formRef.current.contains(e.target as Node)) {
      setErrors({});
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="max-w-full mx-auto">
      <div className="flex flex-col gap-5">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Add Property Structure</h1>
        <div className="p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800">
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              <div>
                <label
                  htmlFor="description_name"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Structure Of Property
                </label>
                <div className="flex">
                <input
                  type="text"
                  id="description_name"
                  name="description_name"
                  value={formData.description_name}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-r-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Submit
                </button>
                </div>
                {errors.description_name && (
                  <p className="text-sm text-red-600 mt-1">{errors.description_name}</p>
                )}
              </div>
            </div>
          </form>

          {successMessage && (
            <div className="mt-4 p-4 bg-green-600 text-white rounded-lg flex justify-between items-center">
              <span>{successMessage}</span>
              <button
                onClick={() => setSuccessMessage('')}
                className="ml-4 text-white font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}

          {dataExistMessage && (
            <div className="mt-4 p-4 bg-yellow-600 text-white rounded-lg flex justify-between items-center">
              <span>{dataExistMessage}</span>
              <button
                onClick={() => setDataExistMessage('')}
                className="ml-4 text-white font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddPropertyStructure;